<template>
  <div class="d-flex flex-column pa-3" style="gap: 10px;">
    <a-pricing-strategy-rule-type-condition-field-range-slider
      :value="occRange"
      :label="$t('If_occupancy_compset')"
      :min="schemaMin('condition_occupancy_from')"
      :max="schemaMax('condition_occupancy_from')"
      unit="%"
      @input="onRangeInput"
    />
  </div>
</template>

<script>
import aPricingStrategyRuleTypeConditionFieldRangeSlider from "./fields/aPricingStrategyRuleTypeConditionFieldRangeSlider.vue";

export default {
  name: "a-pricing-strategy-rule-type-condition-body-occupancy-compset",
  components: { aPricingStrategyRuleTypeConditionFieldRangeSlider },

  props: {
    cond: { type: Object, required: true },
    ruleType: { type: Object, required: true }
  },

  computed: {
    occRange() {
      return [
        this.cond.settings.condition_occupancy_from || 0,
        this.cond.settings.condition_occupancy_to || 100
      ];
    }
  },

  methods: {
    schemaField(field) {
      return (this.ruleType.settings_schema || {})[field] || [];
    },
    schemaMin(field) {
      const r = this.schemaField(field).find(
        r => r && typeof r === "object" && "min" in r
      );
      return r ? r.min : 0;
    },
    schemaMax(field) {
      const r = this.schemaField(field).find(
        r => r && typeof r === "object" && "max" in r
      );
      return r ? r.max : 100;
    },
    onRangeInput(v) {
      this.cond.settings.condition_occupancy_from = v[0];
      this.cond.settings.condition_occupancy_to = v[1];
    }
  }
};
</script>
